<template>
  <h1>Welcome</h1>
  <p>Please select a component from the nav bar to get started.</p>
</template>
